/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Payout admin
 * Payout application
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import {
    type DataTag,
    type DefinedInitialDataOptions,
    type DefinedUseQueryResult,
    type QueryClient,
    type QueryFunction,
    type QueryKey,
    type UndefinedInitialDataOptions,
    type UseQueryOptions,
    type UseQueryResult,
} from '@tanstack/react-query';
import { payoutKyMutator } from '../../shared/api/kyMutator';
import { type ErrorType, type BodyType } from '../../shared/api/kyMutator';
import {
    type AdminPayoutTraderServiceCountTradersParams,
    type AdminPayoutTraderServiceGetTraderBalanceParams,
    type AdminPayoutTraderServiceGetTraderParams,
    type AdminPayoutTraderServiceGetTraderRateParams,
    type AdminPayoutTraderServiceGetUsersTraderParams,
    type AdminPayoutTraderServiceListTradersParams,
    type GoogleRpcStatus,
    type PayoutAdminTraderV1ActivateTraderRequest,
    type PayoutAdminTraderV1ActivateTraderResponse,
    type PayoutAdminTraderV1BlockTraderRequest,
    type PayoutAdminTraderV1BlockTraderResponse,
    type PayoutAdminTraderV1CountTradersResponse,
    type PayoutAdminTraderV1GetTraderBalanceResponse,
    type PayoutAdminTraderV1GetTraderRateResponse,
    type PayoutAdminTraderV1GetTraderResponse,
    type PayoutAdminTraderV1GetUsersTraderResponse,
    type PayoutAdminTraderV1ListTradersResponse,
    type PayoutAdminTraderV1SetTraderWorkingStatusRequest,
    type PayoutAdminTraderV1SetTraderWorkingStatusResponse,
    type PayoutAdminTraderV1UnblockTraderRequest,
    type PayoutAdminTraderV1UnblockTraderResponse,
    type PayoutAdminTraderV1UpdateTraderConfigRequest,
    type PayoutAdminTraderV1UpdateTraderConfigResponse,
    type PayoutAdminTraderV1UpdateTraderConfigV2Request,
    type PayoutAdminTraderV1UpdateTraderConfigV2Response,
    type PayoutAdminTraderV1UpdateTraderRateRequest,
    type PayoutAdminTraderV1UpdateTraderRateResponse,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };

    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === 'queryKey') {
            continue;
        }

        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }

    return result;
};

export const getAdminPayoutTraderServiceGetTraderUrl = (params?: AdminPayoutTraderServiceGetTraderParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/trader?${stringifiedParams}` : '/v1/trader';
};

/**
 * @summary Requires traders.read.
 */
export const adminPayoutTraderServiceGetTrader = async (
    params?: AdminPayoutTraderServiceGetTraderParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminTraderV1GetTraderResponse> => {
    return payoutKyMutator<PayoutAdminTraderV1GetTraderResponse>(getAdminPayoutTraderServiceGetTraderUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayoutTraderServiceGetTraderQueryKey = (params?: AdminPayoutTraderServiceGetTraderParams) => {
    return ['/v1/trader', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutTraderServiceGetTraderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceGetTraderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetTrader>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutTraderServiceGetTraderQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutTraderServiceGetTrader>>> = ({ signal }) =>
        adminPayoutTraderServiceGetTrader(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutTraderServiceGetTrader>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutTraderServiceGetTraderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutTraderServiceGetTrader>>
>;
export type AdminPayoutTraderServiceGetTraderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutTraderServiceGetTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutTraderServiceGetTraderParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetTrader>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceGetTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceGetTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceGetTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceGetTraderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetTrader>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceGetTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceGetTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceGetTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceGetTraderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetTrader>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires traders.read.
 */

export function useAdminPayoutTraderServiceGetTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceGetTraderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetTrader>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutTraderServiceGetTraderQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutTraderServiceActivateTraderUrl = () => {
    return '/v1/trader/activate';
};

/**
 * @summary Requires traders.status.update.
 */
export const adminPayoutTraderServiceActivateTrader = async (
    payoutAdminTraderV1ActivateTraderRequest: PayoutAdminTraderV1ActivateTraderRequest,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminTraderV1ActivateTraderResponse> => {
    return payoutKyMutator<PayoutAdminTraderV1ActivateTraderResponse>(getAdminPayoutTraderServiceActivateTraderUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutAdminTraderV1ActivateTraderRequest),
    });
};

export const getAdminPayoutTraderServiceActivateTraderQueryKey = (
    payoutAdminTraderV1ActivateTraderRequest?: BodyType<PayoutAdminTraderV1ActivateTraderRequest>,
) => {
    return ['PATCH', '/v1/trader/activate', payoutAdminTraderV1ActivateTraderRequest] as const;
};

export const getAdminPayoutTraderServiceActivateTraderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceActivateTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1ActivateTraderRequest: BodyType<PayoutAdminTraderV1ActivateTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceActivateTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayoutTraderServiceActivateTraderQueryKey(payoutAdminTraderV1ActivateTraderRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutTraderServiceActivateTrader>>> = ({ signal }) =>
        adminPayoutTraderServiceActivateTrader(payoutAdminTraderV1ActivateTraderRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutTraderServiceActivateTrader>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutTraderServiceActivateTraderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutTraderServiceActivateTrader>>
>;
export type AdminPayoutTraderServiceActivateTraderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutTraderServiceActivateTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceActivateTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1ActivateTraderRequest: BodyType<PayoutAdminTraderV1ActivateTraderRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceActivateTrader>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceActivateTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceActivateTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceActivateTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceActivateTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1ActivateTraderRequest: BodyType<PayoutAdminTraderV1ActivateTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceActivateTrader>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceActivateTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceActivateTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceActivateTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceActivateTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1ActivateTraderRequest: BodyType<PayoutAdminTraderV1ActivateTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceActivateTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires traders.status.update.
 */

export function useAdminPayoutTraderServiceActivateTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceActivateTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1ActivateTraderRequest: BodyType<PayoutAdminTraderV1ActivateTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceActivateTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutTraderServiceActivateTraderQueryOptions(
        payoutAdminTraderV1ActivateTraderRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutTraderServiceGetTraderBalanceUrl = (
    params?: AdminPayoutTraderServiceGetTraderBalanceParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/trader/balance?${stringifiedParams}` : '/v1/trader/balance';
};

/**
 * @summary Requires traders.balance.read.
 */
export const adminPayoutTraderServiceGetTraderBalance = async (
    params?: AdminPayoutTraderServiceGetTraderBalanceParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminTraderV1GetTraderBalanceResponse> => {
    return payoutKyMutator<PayoutAdminTraderV1GetTraderBalanceResponse>(
        getAdminPayoutTraderServiceGetTraderBalanceUrl(params),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getAdminPayoutTraderServiceGetTraderBalanceQueryKey = (
    params?: AdminPayoutTraderServiceGetTraderBalanceParams,
) => {
    return ['/v1/trader/balance', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutTraderServiceGetTraderBalanceQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderBalance>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceGetTraderBalanceParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderBalance>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutTraderServiceGetTraderBalanceQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderBalance>>> = ({ signal }) =>
        adminPayoutTraderServiceGetTraderBalance(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderBalance>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutTraderServiceGetTraderBalanceQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderBalance>>
>;
export type AdminPayoutTraderServiceGetTraderBalanceQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutTraderServiceGetTraderBalance<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderBalance>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutTraderServiceGetTraderBalanceParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderBalance>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderBalance>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderBalance>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceGetTraderBalance<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderBalance>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceGetTraderBalanceParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderBalance>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderBalance>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderBalance>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceGetTraderBalance<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderBalance>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceGetTraderBalanceParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderBalance>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires traders.balance.read.
 */

export function useAdminPayoutTraderServiceGetTraderBalance<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderBalance>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceGetTraderBalanceParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderBalance>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutTraderServiceGetTraderBalanceQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutTraderServiceBlockTraderUrl = () => {
    return '/v1/trader/block';
};

/**
 * @summary Requires traders.status.update.
 */
export const adminPayoutTraderServiceBlockTrader = async (
    payoutAdminTraderV1BlockTraderRequest: PayoutAdminTraderV1BlockTraderRequest,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminTraderV1BlockTraderResponse> => {
    return payoutKyMutator<PayoutAdminTraderV1BlockTraderResponse>(getAdminPayoutTraderServiceBlockTraderUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutAdminTraderV1BlockTraderRequest),
    });
};

export const getAdminPayoutTraderServiceBlockTraderQueryKey = (
    payoutAdminTraderV1BlockTraderRequest?: BodyType<PayoutAdminTraderV1BlockTraderRequest>,
) => {
    return ['PATCH', '/v1/trader/block', payoutAdminTraderV1BlockTraderRequest] as const;
};

export const getAdminPayoutTraderServiceBlockTraderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceBlockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1BlockTraderRequest: BodyType<PayoutAdminTraderV1BlockTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceBlockTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getAdminPayoutTraderServiceBlockTraderQueryKey(payoutAdminTraderV1BlockTraderRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutTraderServiceBlockTrader>>> = ({ signal }) =>
        adminPayoutTraderServiceBlockTrader(payoutAdminTraderV1BlockTraderRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutTraderServiceBlockTrader>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutTraderServiceBlockTraderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutTraderServiceBlockTrader>>
>;
export type AdminPayoutTraderServiceBlockTraderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutTraderServiceBlockTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceBlockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1BlockTraderRequest: BodyType<PayoutAdminTraderV1BlockTraderRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceBlockTrader>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceBlockTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceBlockTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceBlockTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceBlockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1BlockTraderRequest: BodyType<PayoutAdminTraderV1BlockTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceBlockTrader>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceBlockTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceBlockTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceBlockTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceBlockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1BlockTraderRequest: BodyType<PayoutAdminTraderV1BlockTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceBlockTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires traders.status.update.
 */

export function useAdminPayoutTraderServiceBlockTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceBlockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1BlockTraderRequest: BodyType<PayoutAdminTraderV1BlockTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceBlockTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutTraderServiceBlockTraderQueryOptions(
        payoutAdminTraderV1BlockTraderRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutTraderServiceUpdateTraderConfigUrl = () => {
    return '/v1/trader/config';
};

/**
 * @deprecated
 * @summary Requires traders.config.update.
 */
export const adminPayoutTraderServiceUpdateTraderConfig = async (
    payoutAdminTraderV1UpdateTraderConfigRequest: PayoutAdminTraderV1UpdateTraderConfigRequest,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminTraderV1UpdateTraderConfigResponse> => {
    return payoutKyMutator<PayoutAdminTraderV1UpdateTraderConfigResponse>(
        getAdminPayoutTraderServiceUpdateTraderConfigUrl(),
        {
            ...options,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(payoutAdminTraderV1UpdateTraderConfigRequest),
        },
    );
};

export const getAdminPayoutTraderServiceUpdateTraderConfigQueryKey = (
    payoutAdminTraderV1UpdateTraderConfigRequest?: BodyType<PayoutAdminTraderV1UpdateTraderConfigRequest>,
) => {
    return ['PATCH', '/v1/trader/config', payoutAdminTraderV1UpdateTraderConfigRequest] as const;
};

export const getAdminPayoutTraderServiceUpdateTraderConfigQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfig>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UpdateTraderConfigRequest: BodyType<PayoutAdminTraderV1UpdateTraderConfigRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfig>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayoutTraderServiceUpdateTraderConfigQueryKey(payoutAdminTraderV1UpdateTraderConfigRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfig>>> = ({
        signal,
    }) =>
        adminPayoutTraderServiceUpdateTraderConfig(payoutAdminTraderV1UpdateTraderConfigRequest, {
            signal,
            ...requestOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfig>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutTraderServiceUpdateTraderConfigQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfig>>
>;
export type AdminPayoutTraderServiceUpdateTraderConfigQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutTraderServiceUpdateTraderConfig<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfig>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UpdateTraderConfigRequest: BodyType<PayoutAdminTraderV1UpdateTraderConfigRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfig>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfig>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfig>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceUpdateTraderConfig<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfig>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UpdateTraderConfigRequest: BodyType<PayoutAdminTraderV1UpdateTraderConfigRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfig>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfig>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfig>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceUpdateTraderConfig<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfig>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UpdateTraderConfigRequest: BodyType<PayoutAdminTraderV1UpdateTraderConfigRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfig>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @deprecated
 * @summary Requires traders.config.update.
 */

export function useAdminPayoutTraderServiceUpdateTraderConfig<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfig>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UpdateTraderConfigRequest: BodyType<PayoutAdminTraderV1UpdateTraderConfigRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfig>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutTraderServiceUpdateTraderConfigQueryOptions(
        payoutAdminTraderV1UpdateTraderConfigRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutTraderServiceCountTradersUrl = (params?: AdminPayoutTraderServiceCountTradersParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ['filter.statuses', 'filter.workingStatuses', 'filter.workStrategies'];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/trader/count?${stringifiedParams}` : '/v1/trader/count';
};

/**
 * @summary Requires traders.read.
 */
export const adminPayoutTraderServiceCountTraders = async (
    params?: AdminPayoutTraderServiceCountTradersParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminTraderV1CountTradersResponse> => {
    return payoutKyMutator<PayoutAdminTraderV1CountTradersResponse>(
        getAdminPayoutTraderServiceCountTradersUrl(params),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getAdminPayoutTraderServiceCountTradersQueryKey = (
    params?: AdminPayoutTraderServiceCountTradersParams,
) => {
    return ['/v1/trader/count', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutTraderServiceCountTradersQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceCountTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceCountTradersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceCountTraders>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutTraderServiceCountTradersQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutTraderServiceCountTraders>>> = ({ signal }) =>
        adminPayoutTraderServiceCountTraders(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutTraderServiceCountTraders>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutTraderServiceCountTradersQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutTraderServiceCountTraders>>
>;
export type AdminPayoutTraderServiceCountTradersQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutTraderServiceCountTraders<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceCountTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutTraderServiceCountTradersParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceCountTraders>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceCountTraders>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceCountTraders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceCountTraders<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceCountTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceCountTradersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceCountTraders>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceCountTraders>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceCountTraders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceCountTraders<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceCountTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceCountTradersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceCountTraders>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires traders.read.
 */

export function useAdminPayoutTraderServiceCountTraders<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceCountTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceCountTradersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceCountTraders>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutTraderServiceCountTradersQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutTraderServiceGetTraderRateUrl = (params?: AdminPayoutTraderServiceGetTraderRateParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/trader/rate?${stringifiedParams}` : '/v1/trader/rate';
};

/**
 * @summary Requires traders.rate.read.
 */
export const adminPayoutTraderServiceGetTraderRate = async (
    params?: AdminPayoutTraderServiceGetTraderRateParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminTraderV1GetTraderRateResponse> => {
    return payoutKyMutator<PayoutAdminTraderV1GetTraderRateResponse>(
        getAdminPayoutTraderServiceGetTraderRateUrl(params),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getAdminPayoutTraderServiceGetTraderRateQueryKey = (
    params?: AdminPayoutTraderServiceGetTraderRateParams,
) => {
    return ['/v1/trader/rate', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutTraderServiceGetTraderRateQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderRate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceGetTraderRateParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderRate>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutTraderServiceGetTraderRateQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderRate>>> = ({ signal }) =>
        adminPayoutTraderServiceGetTraderRate(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderRate>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutTraderServiceGetTraderRateQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderRate>>
>;
export type AdminPayoutTraderServiceGetTraderRateQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutTraderServiceGetTraderRate<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderRate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutTraderServiceGetTraderRateParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderRate>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderRate>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderRate>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceGetTraderRate<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderRate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceGetTraderRateParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderRate>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderRate>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderRate>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceGetTraderRate<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderRate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceGetTraderRateParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderRate>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires traders.rate.read.
 */

export function useAdminPayoutTraderServiceGetTraderRate<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderRate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceGetTraderRateParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetTraderRate>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutTraderServiceGetTraderRateQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutTraderServiceUpdateTraderRateUrl = () => {
    return '/v1/trader/rate';
};

/**
 * @summary Requires traders.rate.update.
 */
export const adminPayoutTraderServiceUpdateTraderRate = async (
    payoutAdminTraderV1UpdateTraderRateRequest: PayoutAdminTraderV1UpdateTraderRateRequest,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminTraderV1UpdateTraderRateResponse> => {
    return payoutKyMutator<PayoutAdminTraderV1UpdateTraderRateResponse>(
        getAdminPayoutTraderServiceUpdateTraderRateUrl(),
        {
            ...options,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(payoutAdminTraderV1UpdateTraderRateRequest),
        },
    );
};

export const getAdminPayoutTraderServiceUpdateTraderRateQueryKey = (
    payoutAdminTraderV1UpdateTraderRateRequest?: BodyType<PayoutAdminTraderV1UpdateTraderRateRequest>,
) => {
    return ['PATCH', '/v1/trader/rate', payoutAdminTraderV1UpdateTraderRateRequest] as const;
};

export const getAdminPayoutTraderServiceUpdateTraderRateQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderRate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UpdateTraderRateRequest: BodyType<PayoutAdminTraderV1UpdateTraderRateRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderRate>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayoutTraderServiceUpdateTraderRateQueryKey(payoutAdminTraderV1UpdateTraderRateRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderRate>>> = ({ signal }) =>
        adminPayoutTraderServiceUpdateTraderRate(payoutAdminTraderV1UpdateTraderRateRequest, {
            signal,
            ...requestOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderRate>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutTraderServiceUpdateTraderRateQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderRate>>
>;
export type AdminPayoutTraderServiceUpdateTraderRateQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutTraderServiceUpdateTraderRate<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderRate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UpdateTraderRateRequest: BodyType<PayoutAdminTraderV1UpdateTraderRateRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderRate>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderRate>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderRate>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceUpdateTraderRate<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderRate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UpdateTraderRateRequest: BodyType<PayoutAdminTraderV1UpdateTraderRateRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderRate>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderRate>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderRate>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceUpdateTraderRate<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderRate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UpdateTraderRateRequest: BodyType<PayoutAdminTraderV1UpdateTraderRateRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderRate>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires traders.rate.update.
 */

export function useAdminPayoutTraderServiceUpdateTraderRate<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderRate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UpdateTraderRateRequest: BodyType<PayoutAdminTraderV1UpdateTraderRateRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderRate>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutTraderServiceUpdateTraderRateQueryOptions(
        payoutAdminTraderV1UpdateTraderRateRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutTraderServiceUnblockTraderUrl = () => {
    return '/v1/trader/unblock';
};

/**
 * @summary Requires traders.status.update.
 */
export const adminPayoutTraderServiceUnblockTrader = async (
    payoutAdminTraderV1UnblockTraderRequest: PayoutAdminTraderV1UnblockTraderRequest,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminTraderV1UnblockTraderResponse> => {
    return payoutKyMutator<PayoutAdminTraderV1UnblockTraderResponse>(getAdminPayoutTraderServiceUnblockTraderUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutAdminTraderV1UnblockTraderRequest),
    });
};

export const getAdminPayoutTraderServiceUnblockTraderQueryKey = (
    payoutAdminTraderV1UnblockTraderRequest?: BodyType<PayoutAdminTraderV1UnblockTraderRequest>,
) => {
    return ['PATCH', '/v1/trader/unblock', payoutAdminTraderV1UnblockTraderRequest] as const;
};

export const getAdminPayoutTraderServiceUnblockTraderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUnblockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UnblockTraderRequest: BodyType<PayoutAdminTraderV1UnblockTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUnblockTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayoutTraderServiceUnblockTraderQueryKey(payoutAdminTraderV1UnblockTraderRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutTraderServiceUnblockTrader>>> = ({ signal }) =>
        adminPayoutTraderServiceUnblockTrader(payoutAdminTraderV1UnblockTraderRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutTraderServiceUnblockTrader>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutTraderServiceUnblockTraderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutTraderServiceUnblockTrader>>
>;
export type AdminPayoutTraderServiceUnblockTraderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutTraderServiceUnblockTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUnblockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UnblockTraderRequest: BodyType<PayoutAdminTraderV1UnblockTraderRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUnblockTrader>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceUnblockTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceUnblockTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceUnblockTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUnblockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UnblockTraderRequest: BodyType<PayoutAdminTraderV1UnblockTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUnblockTrader>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceUnblockTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceUnblockTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceUnblockTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUnblockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UnblockTraderRequest: BodyType<PayoutAdminTraderV1UnblockTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUnblockTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires traders.status.update.
 */

export function useAdminPayoutTraderServiceUnblockTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUnblockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UnblockTraderRequest: BodyType<PayoutAdminTraderV1UnblockTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUnblockTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutTraderServiceUnblockTraderQueryOptions(
        payoutAdminTraderV1UnblockTraderRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutTraderServiceSetTraderWorkingStatusUrl = () => {
    return '/v1/trader/working_status';
};

/**
 * @summary Requires traders.status.update.
 */
export const adminPayoutTraderServiceSetTraderWorkingStatus = async (
    payoutAdminTraderV1SetTraderWorkingStatusRequest: PayoutAdminTraderV1SetTraderWorkingStatusRequest,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminTraderV1SetTraderWorkingStatusResponse> => {
    return payoutKyMutator<PayoutAdminTraderV1SetTraderWorkingStatusResponse>(
        getAdminPayoutTraderServiceSetTraderWorkingStatusUrl(),
        {
            ...options,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(payoutAdminTraderV1SetTraderWorkingStatusRequest),
        },
    );
};

export const getAdminPayoutTraderServiceSetTraderWorkingStatusQueryKey = (
    payoutAdminTraderV1SetTraderWorkingStatusRequest?: BodyType<PayoutAdminTraderV1SetTraderWorkingStatusRequest>,
) => {
    return ['PATCH', '/v1/trader/working_status', payoutAdminTraderV1SetTraderWorkingStatusRequest] as const;
};

export const getAdminPayoutTraderServiceSetTraderWorkingStatusQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceSetTraderWorkingStatus>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1SetTraderWorkingStatusRequest: BodyType<PayoutAdminTraderV1SetTraderWorkingStatusRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceSetTraderWorkingStatus>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayoutTraderServiceSetTraderWorkingStatusQueryKey(payoutAdminTraderV1SetTraderWorkingStatusRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutTraderServiceSetTraderWorkingStatus>>> = ({
        signal,
    }) =>
        adminPayoutTraderServiceSetTraderWorkingStatus(payoutAdminTraderV1SetTraderWorkingStatusRequest, {
            signal,
            ...requestOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutTraderServiceSetTraderWorkingStatus>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutTraderServiceSetTraderWorkingStatusQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutTraderServiceSetTraderWorkingStatus>>
>;
export type AdminPayoutTraderServiceSetTraderWorkingStatusQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutTraderServiceSetTraderWorkingStatus<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceSetTraderWorkingStatus>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1SetTraderWorkingStatusRequest: BodyType<PayoutAdminTraderV1SetTraderWorkingStatusRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceSetTraderWorkingStatus>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceSetTraderWorkingStatus>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceSetTraderWorkingStatus>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceSetTraderWorkingStatus<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceSetTraderWorkingStatus>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1SetTraderWorkingStatusRequest: BodyType<PayoutAdminTraderV1SetTraderWorkingStatusRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceSetTraderWorkingStatus>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceSetTraderWorkingStatus>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceSetTraderWorkingStatus>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceSetTraderWorkingStatus<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceSetTraderWorkingStatus>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1SetTraderWorkingStatusRequest: BodyType<PayoutAdminTraderV1SetTraderWorkingStatusRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceSetTraderWorkingStatus>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires traders.status.update.
 */

export function useAdminPayoutTraderServiceSetTraderWorkingStatus<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceSetTraderWorkingStatus>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1SetTraderWorkingStatusRequest: BodyType<PayoutAdminTraderV1SetTraderWorkingStatusRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceSetTraderWorkingStatus>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutTraderServiceSetTraderWorkingStatusQueryOptions(
        payoutAdminTraderV1SetTraderWorkingStatusRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutTraderServiceListTradersUrl = (params?: AdminPayoutTraderServiceListTradersParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ['filter.statuses', 'filter.workingStatuses', 'filter.workStrategies'];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/traders?${stringifiedParams}` : '/v1/traders';
};

/**
 * @summary List payout traders.
Requires traders.read.
 */
export const adminPayoutTraderServiceListTraders = async (
    params?: AdminPayoutTraderServiceListTradersParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminTraderV1ListTradersResponse> => {
    return payoutKyMutator<PayoutAdminTraderV1ListTradersResponse>(getAdminPayoutTraderServiceListTradersUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayoutTraderServiceListTradersQueryKey = (params?: AdminPayoutTraderServiceListTradersParams) => {
    return ['/v1/traders', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutTraderServiceListTradersQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceListTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceListTradersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceListTraders>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutTraderServiceListTradersQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutTraderServiceListTraders>>> = ({ signal }) =>
        adminPayoutTraderServiceListTraders(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutTraderServiceListTraders>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutTraderServiceListTradersQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutTraderServiceListTraders>>
>;
export type AdminPayoutTraderServiceListTradersQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutTraderServiceListTraders<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceListTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutTraderServiceListTradersParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceListTraders>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceListTraders>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceListTraders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceListTraders<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceListTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceListTradersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceListTraders>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceListTraders>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceListTraders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceListTraders<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceListTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceListTradersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceListTraders>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List payout traders.
Requires traders.read.
 */

export function useAdminPayoutTraderServiceListTraders<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceListTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceListTradersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceListTraders>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutTraderServiceListTradersQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutTraderServiceGetUsersTraderUrl = (params?: AdminPayoutTraderServiceGetUsersTraderParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/users/trader?${stringifiedParams}` : '/v1/users/trader';
};

/**
 * @summary Get trader by auth app user
Requires traders.read.
 */
export const adminPayoutTraderServiceGetUsersTrader = async (
    params?: AdminPayoutTraderServiceGetUsersTraderParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminTraderV1GetUsersTraderResponse> => {
    return payoutKyMutator<PayoutAdminTraderV1GetUsersTraderResponse>(
        getAdminPayoutTraderServiceGetUsersTraderUrl(params),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getAdminPayoutTraderServiceGetUsersTraderQueryKey = (
    params?: AdminPayoutTraderServiceGetUsersTraderParams,
) => {
    return ['/v1/users/trader', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutTraderServiceGetUsersTraderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetUsersTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceGetUsersTraderParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetUsersTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutTraderServiceGetUsersTraderQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutTraderServiceGetUsersTrader>>> = ({ signal }) =>
        adminPayoutTraderServiceGetUsersTrader(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutTraderServiceGetUsersTrader>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutTraderServiceGetUsersTraderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutTraderServiceGetUsersTrader>>
>;
export type AdminPayoutTraderServiceGetUsersTraderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutTraderServiceGetUsersTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetUsersTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutTraderServiceGetUsersTraderParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetUsersTrader>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceGetUsersTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceGetUsersTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceGetUsersTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetUsersTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceGetUsersTraderParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetUsersTrader>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceGetUsersTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceGetUsersTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceGetUsersTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetUsersTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceGetUsersTraderParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetUsersTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get trader by auth app user
Requires traders.read.
 */

export function useAdminPayoutTraderServiceGetUsersTrader<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceGetUsersTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutTraderServiceGetUsersTraderParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceGetUsersTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutTraderServiceGetUsersTraderQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutTraderServiceUpdateTraderConfigV2Url = () => {
    return '/v2/trader/config';
};

/**
 * @summary Requires traders.config.update.
 */
export const adminPayoutTraderServiceUpdateTraderConfigV2 = async (
    payoutAdminTraderV1UpdateTraderConfigV2Request: PayoutAdminTraderV1UpdateTraderConfigV2Request,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminTraderV1UpdateTraderConfigV2Response> => {
    return payoutKyMutator<PayoutAdminTraderV1UpdateTraderConfigV2Response>(
        getAdminPayoutTraderServiceUpdateTraderConfigV2Url(),
        {
            ...options,
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(payoutAdminTraderV1UpdateTraderConfigV2Request),
        },
    );
};

export const getAdminPayoutTraderServiceUpdateTraderConfigV2QueryKey = (
    payoutAdminTraderV1UpdateTraderConfigV2Request?: BodyType<PayoutAdminTraderV1UpdateTraderConfigV2Request>,
) => {
    return ['PUT', '/v2/trader/config', payoutAdminTraderV1UpdateTraderConfigV2Request] as const;
};

export const getAdminPayoutTraderServiceUpdateTraderConfigV2QueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfigV2>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UpdateTraderConfigV2Request: BodyType<PayoutAdminTraderV1UpdateTraderConfigV2Request>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfigV2>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayoutTraderServiceUpdateTraderConfigV2QueryKey(payoutAdminTraderV1UpdateTraderConfigV2Request);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfigV2>>> = ({
        signal,
    }) =>
        adminPayoutTraderServiceUpdateTraderConfigV2(payoutAdminTraderV1UpdateTraderConfigV2Request, {
            signal,
            ...requestOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfigV2>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutTraderServiceUpdateTraderConfigV2QueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfigV2>>
>;
export type AdminPayoutTraderServiceUpdateTraderConfigV2QueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutTraderServiceUpdateTraderConfigV2<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfigV2>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UpdateTraderConfigV2Request: BodyType<PayoutAdminTraderV1UpdateTraderConfigV2Request>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfigV2>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfigV2>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfigV2>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceUpdateTraderConfigV2<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfigV2>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UpdateTraderConfigV2Request: BodyType<PayoutAdminTraderV1UpdateTraderConfigV2Request>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfigV2>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfigV2>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfigV2>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutTraderServiceUpdateTraderConfigV2<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfigV2>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UpdateTraderConfigV2Request: BodyType<PayoutAdminTraderV1UpdateTraderConfigV2Request>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfigV2>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires traders.config.update.
 */

export function useAdminPayoutTraderServiceUpdateTraderConfigV2<
    TData = Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfigV2>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminTraderV1UpdateTraderConfigV2Request: BodyType<PayoutAdminTraderV1UpdateTraderConfigV2Request>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutTraderServiceUpdateTraderConfigV2>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutTraderServiceUpdateTraderConfigV2QueryOptions(
        payoutAdminTraderV1UpdateTraderConfigV2Request,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
